import qs from 'qs';
import { verifyResponseStatus, requestBase } from '../helpers';

const apiBase = 'api/account';

const getHeaders = ({ bearer }) => {

	let headers = requestBase.headers;
	headers.set("Authorization", `Bearer ${bearer}`);

	return headers;
}

const accountApi = {
	/**
	 * @typedef {Function} login - 
	 * @param {*} param0 
	 * @returns {Object} login response
	 */
	login: ({ userName, password }) => {
		let request = Object.assign({}, requestBase, { body: JSON.stringify({ userName, password }) });

		return fetch(`${apiBase}/login`, request)
			.then(verifyResponseStatus)
			.then(response => response.json())
			.catch(err => err);
	},
	renewToken: (bearer) => {
		let request = Object.assign({}, requestBase, { headers: getHeaders({ bearer }) });

		return fetch(`${apiBase}/refresh`, request)
			.then(verifyResponseStatus)
			.then(response => response.json())
			.catch(err => err);
	},
	/**
	 * @typedef {Function} passwordReminder - 
	 * @param {*} param0 
	 * @returns {Object} password reminder reponse
	 */
	passwordReminder: ({ userName }) => {
		let request = Object.assign({}, requestBase, { body: JSON.stringify({ userName }) });

		return fetch(`${apiBase}/passwordreminder`, request)
			.then(verifyResponseStatus)
			.then(response => response.json())
			.catch(err => err);
	},
	/**
	 * @typedef {Function} validatePasswordResetToken - 
	 * @param {*} param0 
	 * @returns 
	 */
	validatePasswordResetToken: ({ token }) => {
		let request = Object.assign({}, requestBase, { method: 'GET' });

		let query = qs.stringify({ token }, { allowDots: true });
		let url = `${apiBase}/passwordreset?${query}`;

		return fetch(url, request)
			.then(verifyResponseStatus)
			.then(response => response.json())
			.catch(err => err);
	},
	/**
	 * @typedef {Function} passwordReset - 
	 * @param {*} param0 
	 * @returns 
	 */
	passwordReset: ({ token, password, confirmPassword }) => {
		let request = Object.assign({}, requestBase, { body: JSON.stringify({ token, password, confirmPassword }) });

		return fetch(`${apiBase}/passwordreset`, request)
			.then(verifyResponseStatus)
			.then(response => response.json())
			.catch(err => err);
	}
}

const apiInstance = Object.freeze(accountApi);
export { apiInstance as AccountApi };